import { usePermissions } from '@/context/permissions'
import { NavLink, PageAllTypes, SideLink } from '@/types/utility.types'

export const useFilteredSidelinks = (sidelinks: SideLink[]) => {
  const { permissions } = usePermissions()

  const hasPermission = (uid?: string, action: PageAllTypes = 'list') => {
    return permissions?.some((permission) => {
      const matchesModule = permission.module.module_key === uid
      const hasGrant =
        permission.is_granted ||
        permission.actions.some(
          (a) => a.action_key === action && a.action_value
        )
      return matchesModule && hasGrant
    })
  }

  const filterSubLinks = (subLinks: NavLink[] | undefined) => {
    if (!subLinks) return []
    return subLinks.filter((subLink) =>
      hasPermission(subLink.uid, subLink.action)
    )
  }

  const filterLinks = (links: SideLink[]) => {
    return links
      .filter((link) => !!link) // Remove falsy values
      .map((link) => {
        if (Array.isArray(link?.sub)) {
          const newSub = filterSubLinks(link.sub)
          return newSub.length > 0 ? { ...link, sub: newSub } : null
        }

        return hasPermission(link.uid, link.action) ? link : null
      })
      .filter((link): link is SideLink => link !== null) // Narrow the type
      .sort((a, b) => a.order - b.order) // Sort by order
  }

  return filterLinks(sidelinks)
}
